import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import { BlogDetail } from '../../components/Blog';

const BlogDetailsPage = () => {
  useParams();

  return (
    <Fragment>
      <Header />
      <main className="page_content blog-details-page">
        <BlogDetail />
      </main>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default BlogDetailsPage;